import { createContext } from 'preact';

// Shared context holding singleton services
export const ChatContext = createContext(null);
